import React from 'react';
import { View } from 'react-native';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import IntervalTracker, {
  IntervalTrackerProps,
} from 'shared/components/vxl/ProgressIndicator/IntervalTracker/IntervalTracker';
import StepChecklist, {
  StepChecklistProps,
} from 'shared/components/vxl/ProgressIndicator/StepChecklist/StepChecklist';

export interface StepChecklistTrackerProps {
  stepCheckListData: StepChecklistProps;
  intervalTrackerData: IntervalTrackerProps;
}

const StepChecklistTracker = ({
  stepCheckListData,
  intervalTrackerData,
}: StepChecklistTrackerProps) => {
  const hasSteps = stepCheckListData?.stepperStates?.length;
  const hasIntervals = intervalTrackerData?.trackerStates?.length;

  return (
    <View>
      {hasIntervals ? (
        <IntervalTracker
          trackerStates={intervalTrackerData.trackerStates}
          trackerHeading={intervalTrackerData.trackerHeading}
        />
      ) : null}
      {hasSteps ? <HairLineDivider /> : null}
      {hasSteps ? (
        <StepChecklist
          stepperStates={stepCheckListData.stepperStates}
          stepperHeading={stepCheckListData.stepperHeading}
          tagContent={
            stepCheckListData.tagContent?.text !== undefined
              ? stepCheckListData.tagContent
              : undefined
          }
        />
      ) : null}
    </View>
  );
};

export default StepChecklistTracker;
